import { render, staticRenderFns } from "./solutionDetails2.vue?vue&type=template&id=83573e34&scoped=true&"
import script from "./solutionDetails2.vue?vue&type=script&lang=js&"
export * from "./solutionDetails2.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails2.vue?vue&type=style&index=0&id=83573e34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83573e34",
  null
  
)

export default component.exports